/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Returned_CaptionInputs */

const en_endpoint_returned_caption = /** @type {(inputs: Endpoint_Returned_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the API returned`)
};

const zh_hans1_endpoint_returned_caption = /** @type {(inputs: Endpoint_Returned_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 返回的内容`)
};

const pt_br2_endpoint_returned_caption = /** @type {(inputs: Endpoint_Returned_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que a API retornou`)
};

const es_endpoint_returned_caption = /** @type {(inputs: Endpoint_Returned_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que devolvió la API`)
};

const fr_endpoint_returned_caption = /** @type {(inputs: Endpoint_Returned_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que l’API a renvoyé`)
};

const de_endpoint_returned_caption = /** @type {(inputs: Endpoint_Returned_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was die API zurückgegeben hat`)
};

const ru_endpoint_returned_caption = /** @type {(inputs: Endpoint_Returned_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что вернул API`)
};

const it_endpoint_returned_caption = /** @type {(inputs: Endpoint_Returned_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa ha restituito l'API`)
};

/**
* | output |
* | --- |
* | "What the API returned" |
*
* @param {Endpoint_Returned_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_returned_caption = /** @type {((inputs?: Endpoint_Returned_CaptionInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Returned_CaptionInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_returned_caption(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_returned_caption(inputs)
	if (locale === "es") return es_endpoint_returned_caption(inputs)
	if (locale === "fr") return fr_endpoint_returned_caption(inputs)
	if (locale === "de") return de_endpoint_returned_caption(inputs)
	if (locale === "ru") return ru_endpoint_returned_caption(inputs)
	if (locale === "it") return it_endpoint_returned_caption(inputs)
	return en_endpoint_returned_caption(inputs)
});